import * as z from "zod";

/** The merchant chose HSA/FSA on the unified onboarding picker; posts to the HSA onboarding channel. */
export const notifyHsaPickerSelected = {
  name: "notifyHsaPickerSelected" as const,
  input: z.null(),
  output: z.object({}),
};
